import { AlertTriangle, Info, CheckCircle, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type BannerVariant = "info" | "warning" | "success" | "error";

interface InfoBannerProps {
  message: string;
  variant?: BannerVariant;
  className?: string;
}

const variantStyles: Record<BannerVariant, { bg: string; text: string; icon: typeof Info }> = {
  info: {
    bg: "bg-blue-50 border-blue-200",
    text: "text-blue-800",
    icon: Info,
  },
  warning: {
    bg: "bg-amber-50 border-amber-200",
    text: "text-amber-800",
    icon: AlertTriangle,
  },
  success: {
    bg: "bg-emerald-50 border-emerald-200",
    text: "text-emerald-800",
    icon: CheckCircle,
  },
  error: {
    bg: "bg-red-50 border-red-200",
    text: "text-red-800",
    icon: XCircle,
  },
};

export const InfoBanner = ({ message, variant = "info", className }: InfoBannerProps) => {
  const styles = variantStyles[variant];
  const Icon = styles.icon;

  return (
    <div
      className={cn(
        "flex items-center gap-3 px-4 py-3 rounded-lg border",
        styles.bg,
        styles.text,
        className
      )}
    >
      <Icon className="h-5 w-5 shrink-0" />
      <p className="text-sm">{message}</p>
    </div>
  );
};
